import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

faker.seed(1);

export default Factory.extend({
	connectionDate: () => faker.date.past().toISOString(),
	IP: () => faker.internet.ipv4(),
});
